export const categoryEmergency = [
  'Medical',
  'Accident',
  'Fire',
  'Police',
  'Others',
]

export const actionTaken = [
  {
    value: 'dispatch-first-responder',
    name: 'Dispatch First Responder',
  },
  { value: 'dispatch-ambulance', name: 'Dispatch Ambulance' },
  {
    value: 'dispatch-3rd-party-ambulance-partner',
    name: 'Dispatch 3rd Party Ambulance Partner',
  },
  { value: 'Dispatch-EKSAMS-ambulance', name: 'Dispatch EKSAMS Ambulance' },
  {
    value: 'EKSAMS-phone-first-aid-provided',
    name: 'EKSAMS Phone First-Aid Provided',
  },
  { value: 'respond-on-phone', name: 'Respond on Phone' },
  { value: 'Phone-first-aid', name: 'Phone First Aid' },
  { value: 'refer', name: 'Refer' },
  { value: 'other', name: 'other' },
]

export const getActionTakenItems = () => {
  return [
    {
      value: 'dispatch-first-responder',
      name: 'CBFR',
    },
    { value: 'dispatch-ambulance', name: 'Ambulance Transporter' },
    { value: 'hospital-request', name: 'Hospital' },
  ]
}

export const provisionalDiagnoses = {
  provisionalDaignosis: [
    {
      code: 'abdominal-pain-problems',
      name: 'Abdominal Pain/Problems',
      questions: [
        'What is the location of the abdominal pain?',
        'Is the pain due to an injury to the patient?',
        'How does the patient feel sitting up?',
        'Is the pain above or below the belly button?',
        'If the patient is female between 12-50 years: Could she be pregnant?',
        'Has there been vaginal bleeding? If yes, How much?',
        'Has she said she felt dizzy?',
        'Has the patient vomited? If yes, What does the vomit look like?',
        "Are the patient's bowel movements black and tarry?",
        'Does the patient have recent trauma or any other medical or surgical history?',
      ],
      probableCause: [
        'Indigestion',
        'Gallstones',
        'Cholecystitis',
        'Pregnancy',
        'IBD (Ulcerative Colitis and Crohn’s Disease)',
        'Appendicitis',
        'Ulcer',
        'Gastritis',
        'Pancreatitis',
        'Gastroenteritis',
        'Nephrolithiasis',
        'Endometriosis',
        'GERD',
        'Food Poisoning',
        'Menstrual Cramp',
        'Constipation',
        'Trauma',
        'Lactose Intolerance',
        'Celiac Disease',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Monitor for shock: Skin cool and clammy or mottled, rapid shallow breathing, fatigue, altered mental state, dilated pupils.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Vomiting blood (red/dark red) or coffee ground-like substance. -Black tarry stool. -Lower abdominal pain, woman 12-50 years (if associated with dizziness or fainting or heavy vaginal bleeding).- Upper abdominal pain with prior history of heart problem.- Abdominal pain with fainting or near fainting, patient over 50 yrs.- Fainting/near fainting when sitting. (hypotension)',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            'Pain with vomiting. -Flank pain (Kidney stone). -Abdominal (non-traumatic). -Pain unspecified.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            'Pain with vomiting. -Flank pain (Kidney stone). -Abdominal (non-traumatic). -Pain unspecified.',
        },
      ],
    },
    {
      code: 'allergies-reactions-envenomations-stings-bites',
      name: 'Allergies (Reactions)/Envenomations (Stings, Bites)',
      questions: [
        'Does the patient have a history of a reaction to anything? If Yes,   Describe the reaction the patient had before.',
        'Is the patient having: difficulty swallowing? difficulty breathing? or both?',
        'Is the patient complaining of itching, hives, or rash?',
        'Are the symptoms getting worse?',
        'How does the patient act when they sit up?',
      ],
      probableCause: [
        'Medication',
        'Insect or animal',
        'Airborne e.g mould, dustmite, pollen, etc',
        'Foods',
        'Hay fever',
        'Atopic and Contact Dermatitis',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Brush the stinger off, if possible. Do not attempt to grasp stinger. Apply ice to the site of sting.Have the patient rest in the most comfortable position. Keep neck straight – remove pillows. Watch patients for signs of difficulty breathing (slow breathing), or cardiac arrest. ',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Unconscious/not breathing normally. -Decreased level of consciousness. -Difficulty breathing. -Difficulty swallowing.-Cannot talk in full sentences. -Swelling in the throat or on the face.- Fainting.- History of severe reaction. Itching or hives in multiple areas.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-Concern about reaction, but no history.- Reaction present for a long time (hours), no difficulty breathing. -Itching or hives in one area.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-Concern about reaction, but no history.- Reaction present for a long time (hours), no difficulty breathing. -Itching or hives in one area.',
        },
      ],
    },
    {
      code: 'animal-bites-attacks',
      name: 'Animal Bites/Attacks',
      questions: [
        'Is the animal/human contained?',
        'What type of animal bit the patient?',
        'Is the patient short of breath or does it hurt to breathe?',
        'What part of the body was bitten?',
        'Is the patient bleeding?',
        'How long ago was the bite?',
      ],
      probableCause: ['Domestic', 'Wild', 'Infected'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Contain the animal/human if possibleIf little or no bleeding irrigate with copious amounts of clean waterLet the patient lie down and keep warm with clothingFor snake bites: apply direct pressure to the wound, do not elevate extremity, do not use ice, do not attempt to remove venom',
        },
        Caller: {
          Text: 'Contain the animal/human if possible.If little or no bleeding irrigate with copious amounts of clean waterLet the patient lie down and keep warm with clothingFor snake bites: apply direct pressure to the wound, do not elevate extremity, do not use ice, do not attempt to remove venom',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '–unconscious/not breathing normally-decreased level of consciousness-uncontrolled bleeding,-serious neck/face bites -bites from known poisonous animals',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-controlled bleeding-swelling at bite site-bite below neck-non poisonous bites',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-controlled bleeding-swelling at bite site-bite below neck-non poisonous bites',
        },
      ],
    },
    {
      code: 'assault-sexual-assault-stun-gun',
      name: 'Assault/Sexual Assault/Stun Gun',
      questions: [
        'Is the assailant nearby?',
        'Are you safe?',
        'Was it a physical or sexual assault?',
        'How was the victim assaulted? (stabbing, gunshot or major trauma)',
        'What part of the patient is injured?',
        'Is the patient bleeding?',
      ],
      probableCause: ['Closely related', 'Stranger'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Notify the police and take sexual assault center like Mirabel Center Alausa Ikeja for forensic and medical help.',
        },
        Caller: {
          Text: 'Remain in a safe place, away from the assailantObtain description of assailant(s)Have the patient lie down and try to keep calm and warm with clothingDo not touch weaponsSEXUAL ASSAULTS: advise not to change clothing, bathe or showerDo not allow patient any food or drink',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-unconscious/not breathing normally-decreased level of consciousness-crushing injury-puncture injury-multiple extremity fracture-uncontrolled bleeding',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-isolated extremity fracture-minor injuries-concerned caller without apparent injuries to victims',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-isolated extremity fracture-minor injuries-concerned caller without apparent injuries to victims',
        },
      ],
    },
    {
      code: 'back-pain-non-traumatic-non-recent-trauma',
      name: 'Back Pain (Non-Traumatic Or Non-Recent Trauma)',
      questions: [
        'Has the patient felt dizzy or fainted?',
        'Does the patient have any other medical or surgical history?',
        'Is the patient’s pain due to an injury or recent fall?',
        'Is the patient incontinent of urine or have urinary retention?',
        'Does the patient take blood thinners?',
      ],
      probableCause: [
        'Muscle/Ligament Strain',
        'Bulging or Ruptured',
        'Disks',
        'Arthritis',
        'Osteoporosis',
        'Nephrolithiasis',
        'Scoliosis',
        'Tumours',
        'Pregnancy',
        'Osteomyelitis',
        'UTI',
        'Fibromyalgia',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'If the pain is due to an injury, tell the patient not to move unless hazards are present. Nothing to eat or drink. Have the patient rest in the most comfortable position.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            'Decreased level of consciousness-Non-traumatic back pain with prior history of heart problem. -Back pain with fainting or near fainting, patient over 50 years',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-Flank pain/back (Kidney stone).- Back pain (non-traumatic).- Back pain unspecified.-Chronic back pain',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-Flank pain/back (Kidney stone).- Back pain (non-traumatic).- Back pain unspecified.-Chronic back pain',
        },
      ],
    },
    {
      code: 'bleeding-laceration',
      name: 'Bleeding/Laceration',
      questions: [
        'Where is the bleeding from?',
        'If the patient is female with vaginal bleeding, could she be pregnant? If yes dispatch for pregnancy/childbirth care If no, does she have pain in the abdomen?',
        'How much blood can yousee?',
        'How long have they been bleeding?',
        'Is blood squirting out? (arterial bleeding)',
        'Is the patient a haemophilic (a bleeder)?',
        'Is the person on any blood thinner?',
        'Keep the tool safe.',
        'Has the patient recently travelled to endemic areas with bleeding infectious conditions?',
      ],
      probableCause: [
        'Clotting Disorder',
        'Cancer',
        'Complications from Medical Procedures',
        'Haemophilia',
        'Cold Climate',
        'Fracture',
        'TBI',
        'VHF (Viral Hemorrhagic Fever)',
        'Sharp',
        'Blun',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Have the patient lie down, keep calm and warmAdvise patient not to move, eat or drink anything',
        },
        Caller: {
          Text: 'if bleeding, use clean cloth and apply pressure directly over wound, do not remove, if cloth becomes soaked, add more to what is already there. Elevate bleeding extremities. If tourniquet is available apply.If nose bleed, tell the patient to apply direct pressure by pinching the nose tightly between their index finger and thumb, sit forward and hold it until help arrives. Attempt to spit out blood, as swallowing may make patient nauseousLocate any amputated parts and place in clean plastic bagIf teeth, locate, do not touch the root, and place them in container containing milk or clean water',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-decreased level of consciousness-any arterial bleeding-rectal bleeding with significant blood loss-vomiting blood or coffee ground material-bleeding from mouth with difficulty breathing-bleeding from the neck, groin, or armpit with significant blood loss-vaginal bleeding associated with lower abdominal pain or fainting',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-minor bleeding from any other area that can be controlled by direct pressure',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-minor bleeding from any other area that can be controlled by direct pressure',
        },
      ],
    },
    {
      code: 'breathing-problems',
      name: 'Breathing Problems',
      questions: [
        'Is the patient on asthma medication, or ever used them?',
        'Is the patient able to speak in full sentences?',
        'Is the patient drooling or having a hard time swallowing?',
        'What has changed about their breathing to prompt you to call?',
        'Has the patient ever had this problem before?',
        'How long has this been going on?',
        'Does the patient have to sit up to breathe?',
        'What was the patient doing just prior to when he/she became short of breath?',
        'Does the patient have any other medical or surgical history?',
        'Does the patient have any allergies?',
        'If sudden onset: Has the patient been hospitalized recently for childbirth or a broken leg?',
        'If female, Does the patient take medication for birth control?',
      ],
      probableCause: [
        'Sinusitis',
        'Anxiety',
        'Asthma',
        'Emphysema',
        'Pregnancy',
        'Heart Attack',
        'COPD',
        'Allergies/Anaphylaxis',
        'Tuberculosis',
        'COVID-19',
        'Heart Failure',
        'Lung Collapse',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Keep the patient calm. Patient may be more comfortable sitting up. Tell the patient not to exert him/herself.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            'Any patient complaining of breathing or respiratory difficulty, examples of symptoms may include: Difficulty breathing with chest pain. Unable to speak in full sentences. History of Asthma or respiratory problems. Inhaled substance. Recent childbirth/broken leg/hospitalization (within 2-3 months). Drooling/difficulty swallowing. Tingling or numbness in extremities/around mouth, 35 or older.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            'Cold symptoms. Stuffy nose / congestion. Oxygen bottles empty at home and require assistance.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            'Cold symptoms. Stuffy nose / congestion. Oxygen bottles empty at home and require assistance.',
        },
      ],
    },
    {
      code: 'burns-scalds-explosion-blast',
      name: 'Burns (Scalds)/Explosion (Blast)',
      questions: [
        'How was the patient burned?',
        'Is anything on the patient still burning?  If yes, stop the burning. Place burned area in cool water',
        'If chemical, what chemical caused the burn?',
        'How long have they been bleeding?',
        'Where is the patient burned?',
        'If head or face, is the patient short of breath, coughing or does it hurt to breathe, is the patient having difficulty swallowing, are there burns around their mouth and nose?',
        'Are there any other injuries?',
      ],
      probableCause: [
        'Fire',
        'Explosion',
        'Chemicals',
        'Radiation',
        'Electricity',
        'Does UV Light/Sun',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: '',
        },
        Caller: {
          Text: 'Thermal: place burned area in cool waterChemical: have patient remove contaminated clothing, get information on chemical, if chemical is powder, brush off, flush chemical burns from eyes with water, remove contact lenses if present',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-decreased level of consciousness-burns to airway, nose, mouth-hoarseness, difficulty talking or swallowing-burns over 20% of body surface-electrical burns/electrocution from 220 volts or greater power lines/panel boxes-2nd and 3rd degree burns',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-less than 20% body surface burned-spilled hot liquids-chemical burns to eyes-small burn from match, cigarette-household electric shock-battery explosion-freezer burns',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-less than 20% body surface burned-spilled hot liquids-chemical burns to eyes-small burn from match, cigarette-household electric shock-battery explosion-freezer burns',
        },
      ],
    },
    {
      code: 'carbon-monoxide-inhalation-hazmat-cbrn',
      name: 'Carbon Monoxide/Inhalation/HAZMAT/CBRN',
      questions: [
        'Is a CO Detector activated?',
        'Is the patient complaining of: Headache, confusion,weakness, fatigue, nausea, vomiting or dizziness?',
        'Is patient breathing normally? If NO, go to the breathing problems section?',
        'Inhalations: What is the name of the inhaled substance?',
        'What is the source of the inhaled substance?',
      ],
      probableCause: [
        'Indoor Grill',
        'Indoor Generator',
        'Fire emergency',
        'Smoke inhalation',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Get patient to fresh air immediately.If unable to go outside, open all doors and windows. If the caller is unable to move the patient or open windows ask the caller to remain outside until help arrives.                                                                                          Turn off any appliance with an open flame. (heaters, stoves, fireplaces, etc.)',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            'CO Detector activation with Critical Symptoms:-Unconscious/LOC/not breathing normally.-Decreased level of consciousness. -Inhalation household cleaners, antifreeze, solvents, methanol, cyanide, or insecticides with difficulty swallowing/breathing.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-Chemicals on patient’s skin or clothing, no critical symptoms. -Third party report, caller not with patient.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-Chemicals on patient’s skin or clothing, no critical symptoms. -Third party report, caller not with patient.',
        },
      ],
    },
    {
      code: 'cardiac-respiratory-arrest-death',
      name: 'Cardiac or Respiratory Arrest/Death',
      questions: [
        'If unsure about consciousness :  Does the patient respond to you? Talk to you? Answer questions? Hear you? Does the patient move? Flinch? Move arms or legs?',
        'If unsure about breathing: Look and see if the chest rises and falls. Listen for the sound, frequency and description of breaths.',
        'Agonal respirations are often reported as: gasping, snoring, or gurgling barely breathing moaning weak or heavy occasional?',
      ],
      probableCause: [
        'Arrhythmia',
        'CAD',
        'Herat Attack',
        'Cardiomyopathy',
        'Valvular Heart Disease',
        'congenital Heart Disease',
        'Electrical Problems of the Heart',
        'Stroke',
        'Drug Overdose',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Tell the caller to be calm as possibleEnsure that all dangers are removed Let the patient lie down flat on the backGet someone else to assist, if possibleTell the caller to get a cordless phone and stay on the phone till the responders arrive Tell the caller to begin chest compression and rescue breathe using appropriate technique as stipulated in BLS protocol for age.Use AED if available.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Unresponsive Unconscious/not breathing adequately (Agonal) or not at all.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description: '-Patients on end-of-life care;  Expected death',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description: '-Patients on end-of-life care;  Expected death',
        },
      ],
    },
    {
      code: 'chest-pain-chest-discomfort-non-traumatic',
      name: 'Chest Pain/Chest Discomfort (Non-Traumatic)',
      questions: [
        'Where in the chest is the pain located?',
        'Does the patient feel pain anywhere else? If so, where?',
        'How long has the pain been present?',
        'Is the patient sweating profusely?',
        'Is the patient nauseated or vomiting?',
        'Is the patient weak, dizzy, or faint?',
        'How does the patient act when he/she sits up?',
        'Does the pain change when the person breathes or moves?',
        'Has the patient ever had a heart problem, heart surgery, a device to help their heart work or a previous heart attack?',
        'Is the patient experiencing rapid heart rate with chest pain?',
      ],
      probableCause: [
        'Muscle Strain',
        'Peptic Ulcer Disease',
        'GERD',
        'Asthma',
        'Lung Collpase',
        'Costochondritis',
        'Esophageal Contraction Disorders',
        'Oesophagal Rupture',
        'Oesophagal Hypersensitivity',
        'Hiatal Hernia',
        'HCM',
        'TB',
        'Mital Valve Prolapse',
        'Panic Attack',
        'Pericarditis',
        'Pleurisy',
        'Pneumonia',
        'PE',
        'Heart Attack',
        'Myocarditis',
        'Angina',
        'Aortic Dissection',
        'CAD',
        'Pulmonary HTN',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Have the patient sit or lie down, whichever is more comfortable.Keep the patient calm. Loosen any tight clothing. Gather patient medications at home and keep together for the first responder to review.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            'Patient over 35 with any critical symptom.- Decreased level of consciousness. -Patient complaining of chest pain with any of the critical symptoms: Short of breath,nausea, diaphoretic (sweating profusely), rapid heart rate, syncope (weak, dizzy or faint) or with cocaine/crack (drug) use.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description: 'Patients under 35, without critical symptoms',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description: 'Patients under 35, without critical symptoms',
        },
      ],
    },
    {
      code: 'choking',
      name: 'Choking',
      questions: [
        'Where is the person located?',
        'Is the person sitting or lying?',
        'Is the person coughing?',
        'Can the person speak?',
        'Is the person breathing or making abnormal sounds that are noisy or squeaky?',
        'Does the person have a flushed appearance?',
        'What was ingested if they know?',
        'Is the person unconscious?',
        'Does the person have purplish or bluish discolouration of the skin, lips and nails?',
      ],
      probableCause: ['Swallowing', 'Inhalation'],
      instructions: {},
      determinants: [],
    },
    {
      code: 'convulsions-seizures',
      name: 'Convulsions/Seizures',
      questions: [
        'Is the patient still seizing? IF YES How long has the patient been seizing?',
        'Has the patient had a seizure before?',
        'Is the patient on medication or is he/she a recreational drug user?',
        'Has the patient had a recent head injury?',
        'Is the patient a diabetic? Consider diabetic problems?',
        'IF PATIENT IS A CHILD: Has the child been sick?',
        'Does the child have a fever or feel hot?',
        'IF PATIENT IS FEMALE: “ Is the woman pregnant?',
      ],
      probableCause: [
        'Genetic',
        'Head Trauma',
        'Brain Tumor',
        'Stroke',
        'Infection',
        'Low Blood Sugar',
        'Alcohol/Drug Withdrawal',
        'Medication',
        'Autoimmune Disorder',
        'COVID-19',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: "Clear area around the patient. Do not restrain the patient. Do not place anything in a patient's mouth. If patient is a child, remove clothing to cool patient if hot and feverish After the seizure has stopped, check to see if the patient is breathing. IF NO, Determine appropriate age group. Go to cardiac arrest instructions for the appropriate age group. . IF YES, Have the patient lie on their side. Monitor breathing. Gather patient medications, if any.",
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Decreased level of consciousness. -Not breathing after seizure stops. -Extended seizures greater than 5 minutes.- Multiple seizures.- Febrile seizures.- First time seizure or seizure, unknown history. -Secondary to drug overdose, diabetic, pregnancy, or recent head injury. Any seizure that is different than normal.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description: '-Single seizure with history of seizure disorder.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description: 'Single seizure with history of seizure disorder.',
        },
      ],
    },
    {
      code: 'diabetic-problems',
      name: 'Diabetic Problems',
      questions: [
        'Is the patient on insulin? If so, When did they take their medication?',
        'When did the patient last eat?',
        'Does the patient have a glucose meter? If Yes, Do you have a current level? (Range usually between 70 and 180) ',
        'Is the patient acting in their normal manner? If not, What is different?',
        'Are they dizzy, weak, or feeling faint?',
        'Is the patient complaining of any pain? Where is it located?',
        'Is the patient sweating profusely?',
        'Has the patient had a seizure?',
      ],
      probableCause: ['Hypoglycemia', 'Hyperglycemia', 'DKA', 'HHS'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Nothing by mouth if the patient is unable to take it by himself/herself. IF the patient is conscious enough to swallow and the patient’s blood glucose level is known and is below 70 mg/dl or the blood glucose level is NOT KNOWN, and the patient is acting inappropriately then give juice with 2 to 3 teaspoons of sugar in it. (Giving this amount of sugar to a person with high blood glucose levels will not hurt them and may help a person with low levels).Allow the patient to find a comfortable position. Gather patient medications',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Unconscious/not breathing normally. -Decreased level of consciousness. -Unusual behavior/acting strange. -Profuse sweating. -Seizure',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description: '-Awake/alert.- Not feeling well',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description: '-Awake/alert.- Not feeling well',
        },
      ],
    },
    {
      code: 'drowning-near-drowning-diving-scuba-accident',
      name: 'Drowning/Near Drowning/Diving/SCUBA Accident',
      questions: [
        'Has the patient been removed from the water?, IF YES Is the patient on land or in a boat?',
        'How long was the patient under water?',
        'Is this a scuba diving accident?',
        'What was the patient doing before the accident?',
      ],
      probableCause: ['Bath Tub', 'Pool', 'Beach', 'River', 'Sea', 'Ocean'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Do not attempt to rescue the patient, unless trained to do so. Do not move the patient around. Keep the patient warm.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Unconscious, not breathing normally. -Difficulty breathing. -Scuba diving accident. -Diving accident (possibility of C-spine injury). -Fractured femur (thigh).',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            'Patient not submerged.- Patient coughing. -Other injuries without critical symptoms.- Minor injury (lacerations/fractures).',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            'Patient not submerged.- Patient coughing. -Other injuries without critical symptoms.- Minor injury (lacerations/fractures).',
        },
      ],
    },
    {
      code: 'electrocution-lightning',
      name: 'Electrocution/Lightning',
      questions: [
        'What was the source of the electricity?',
        '(Small household appliance(110 volt AC), dryer, stove, (220 volt AC) or industrial equipment (high voltage DC)',
        'Is the patient still in contact with the source? IF YES, “Do you know how to turn off the electricity?',
        'After patient is removed from electrical circuit check breathing and level of consciousness?',
        'Are there any other injuries?  IF YES What are they?',
      ],
      probableCause: ['Gadget', 'Transformer', 'Explosion'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Beware of liquid spills or ground moisture that could conduct electricity Do not touch the patient(s) if they are in contact with the source of electricity. If it is safe to do so, turn off the power.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Decreased level of consciousness. -Unable to remove the patient from the electrical circuit. -Multiple Casualty Incident Criteria. -Burns to the airway, nose, or mouth. -Burns over 20% of the body surface.- Burns from 220 volt or higher source. -2nd & 3rd degree burns (partial or full thickness) to Palms (hands), Soles (feet) or Groin.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description: '-Household electrical shock without critical symptoms.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description: '-Household electrical shock without critical symptoms.',
        },
      ],
    },
    {
      code: 'eye-problems-injuries',
      name: 'Eye Problems/Injuries',
      questions: [
        'What caused the injury?',
        'Is eyeball cut open or leaking fluid?',
        'Are there any other injuries?',
      ],
      probableCause: [
        'Trauma',
        'Infection',
        'Cataract',
        'Surgery Complications',
        'Conjunctivitis',
        'Glaucoma',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: '',
        },
        Caller: {
          Text: 'Do not remove any penetrating objectsIf eyeball is cut or injured, do not touch, irrigate or bandage,If a chemical injury, flush immediately with water and continue till help arrives.Remove contact lensesAdvise patient not to moveHave patient sit down and keep warm Do not eat or drink',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-unconscious/not breathing normally-decreased level of consciousness-uncontrolled bleeding',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-any eye injury without other injury or complication to other body parts',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-any eye injury without other injury or complication to other body parts',
        },
      ],
    },
    {
      code: 'falls',
      name: 'Falls',
      questions: [
        'Are there any other injuries?',
        'How far did the patient fall?',
        'What kind of surface did the patient land on?',
        'Are there any obvious injuries? What are they?',
        'Did the patient complain of any pain or illness just prior to the fall?',
        'Is the patient able to move their fingers and toes? (do not have them move any other body part)',
        'Is the patient bleeding? If yes go to bleeding/laceration',
      ],
      probableCause: ['Furniture', 'Building', 'Vehicle', 'Stage'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: '',
        },
        Caller: {
          Text: 'Do not move the patient if there is no hazardsAdvise patient not to moveHave the patient lie down, keep calm and warmNo food or drink',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-decreased level of consciousness-signs/symptoms of shock-fall greater than 10 feet-falls associated with or preceded by pain, discomfort in chest, dizziness, headache or diabetes-patient paralysed-uncontrolled bleeding-multiple extremity fractures-femoral (thigh) fracture',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-unconscious, but now conscious with critical symptoms-falls less than 10 feet-neck or back pain without critical symptoms-controlled bleeding-cuts, bumps, or bruises-isolated extremity fracture',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-unconscious, but now conscious with critical symptoms-falls less than 10 feet-neck or back pain without critical symptoms-controlled bleeding-cuts, bumps, or bruises-isolated extremity fracture',
        },
      ],
    },
    {
      code: 'haemorrhage-laceration',
      name: 'Haemorrhage/Laceration',
      questions: [
        'Is the person in danger?',
        'Location of the bleeding or laceration?',
        'How deep is the injury?',
        'Is the person still bleeding?',
        'Keep the tool out of reach.',
        'How much blood can you see?',
        'How long have they been bleeding?',
        'Is blood squirting out? (arterial bleeding)',
        'Is the patient a haemophilic (a bleeder)?',
        'Is the person diabetic or on any blood-thinning medication?',
        'Does the injured arealook clean?',
        'Does the person lookpale?',
        'Is the person dehydrated?',
        'Is the person weak?',
        'Is the person unconscious?',
      ],
      probableCause: [
        'Clotting Disorder',
        'Cancer',
        'Complications from Medical Procedures',
        'Haemophilia',
        'Cold Climate',
        'Fracture',
        'TBI',
        'VHF (Viral Hemorrhagic Fever)',
        'Sharp',
        'Blunt',
      ],
      instructions: {},
      determinants: [],
    },
    {
      code: 'headache',
      name: 'Headache',
      questions: [
        'Does the patient have a headache history?',
        'Is the headache different from headaches the patient has had in the past?',
        'Did the headache come on suddenly or gradually?',
        'What was the patient doing when the headache started?',
        'How is the patient acting? If unusual, how?',
        'Does the patient take blood thinners?',
        'Does the patient know where they are and who they are?',
        'Does the patient have pain anywhere else? IF YES, Where?',
        'Has the patient had a recent illness, injury or trip to an Emergency Department? IF YES, for what?',
      ],
      probableCause: [
        'Alcohol',
        'Depression',
        'Medication',
        'Eye pain',
        'Migraine',
        'Cluster',
        'Sinus',
        'Fever',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Nothing by mouth. Allow the patient to find a position of comfort. Gather patients medications',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Headache with these critical symptoms: Decreased level of consciousness. Mental status change. Worst headache ever. Sudden onset. Visual disturbance, with no history of migraines',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description: '-Headache without critical symptoms.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description: '-Headache without critical symptoms.',
        },
      ],
    },
    {
      code: 'heart-problems',
      name: 'Heart Problems',
      questions: [
        'Where in the chest is the pain located?',
        'Does the patient feel pain anywhere else? If so, where?',
        'How long has the pain been present?',
        'Is the patient sweating profusely?',
        'Is the patient nauseated or vomiting?',
        'Is the patient weak, dizzy, or faint?',
        'How does the patient act when he/she sits up?',
        'Does the pain change when the person breathes or moves?',
        'Has the patient ever had a heart problem, heart surgery, a device to help their heart work or a previous heart attack?',
        'Is the patient experiencing rapid heart rate with chest pain?',
        'How many pillows does the person use to sleep?',
        'Can the person successfully climb a flight of stairs without stopping between to catch breadth?',
        'Any fever in the last 2 weeks?',
      ],
    },
    {
      code: 'heat-cold-exposure',
      name: 'Heat/Cold Exposure',
      questions: [
        'Is the person conscious?',
        'Is the person’s temperature extreme e.g 35°Cand 40°C?',
        'Is the person red, hot, and dry skin (no sweating)?',
        'Is the person’s pulse rapid, strong?',
        'Is the person complaining of throbbing headache',
        'Is the person dizzy?',
        'Any Nausea and Confusion?',
        'Is the person unconscious?',
      ],
      probableCause: ['Frostbite', 'Sun'],
      instructions: {},
      determinants: [],
    },
    {
      code: 'inaccessible-incident',
      name: 'Inaccessible Incident',
      questions: [
        'What is making it inaccessible?',
        'Are you safe?',
        'Is the person safe?',
        'Do you need extra tools and help?',
        'Can you get some more information about the incident while waiting for it to be accessible?',
      ],
      probableCause: ['Building Collapse', 'Vehicle Collision', 'Fire'],
    },
    {
      code: 'industrial-accidents',
      name: 'Industrial Accidents',
      questions: [
        'What happened?',
        'If a patient is trapped in or under an object, what part of the person is trapped?',
        'Are there any obvious injuries? What are they?',
        'If amputation, what part of the body has been amputated? Do you have the amputated parts?',
        'If bleeding go to bleeding/laceration',
        'If burned go to burns',
        'If electrocution go to electrocution section',
        'Is the patient able to move their fingers and toes? (do not have them move any other parts of their body)',
      ],
      probableCause: ['Fall', 'Cut', 'Collision', 'Explosion'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: '',
        },
        Caller: {
          Text: 'If machinery involved, turn it offDo not move patient if there are no hazardsAdvise patient not to moveDo not enter a confined space to tend to the patientHave someone meet the ambulance to guide them to the patientHave the patient lie down, keep calm and warmNo food or drinkLocate any amputated parts and place in clean plastic bag',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-decreased level of consciousness-accident with crushing or penetrating injury to head, neck, torso. Thigh-patient entrapped-patient paralysed-amputation other than fingers/toes-uncontrolled bleeding-multiple extremities fractures-femur (thigh) fracture',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-unconscious but now conscious without critical symptoms-amputation/entrapment of fingers/toes-neck or back pain without critical symptoms-controlled bleeding-cuts, bumps, or bruises-involved in accident, no complaints',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-unconscious but now conscious without critical symptoms-amputation/entrapment of fingers/toes-neck or back pain without critical symptoms-controlled bleeding-cuts, bumps, or bruises-involved in accident, no complaints',
        },
      ],
    },
    {
      code: 'infectious-disease',
      name: 'Infectious Disease',
      questions: [
        'Does the patient have a fever?',
        'Is the patient coughing?',
        'Is there any difficulty with breathing?',
        'Is there bleeding from at least two site mouth, nose, urine, skin, stool)',
        'Any history of contact with someone with similar condition?',
        'Any history of travel to endemic areas of similar conditions?',
      ],
      probableCause: [
        'Ebola',
        'Lassa Fever',
        'TB',
        'Hepatitis',
        'COVID-19',
        'Bird Flu',
        'STI',
        'Yellow Fever',
        'Typhoid',
      ],
      instructions: {
        Responders: {
          Text: 'Responders should be advised to use personal protective equipments',
        },
        Caller: {
          Text: 'Keep calm as much as possible, Wear a facemask for both patient and people around if possible, Let the patient lie on his left side orsit up',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            'If there is a YES response to at least 3 of these key questions',
        },
      ],
    },
    {
      code: 'move-a-patient-between-hospitals',
      name: 'Move A Patient Between Hospitals',
      questions: [
        'What are they transferring the person for?',
        'Is the person stable?',
        'For what is the person being managed?',
      ],
      probableCause: [
        'Palliative',
        'Intensive Care',
        'Specialised Management',
        'Observation',
      ],
      instructions: {},
      determinants: [],
    },
    {
      code: 'others',
      name: 'Others',
      questions: [],
      probableCause: ['Others'],
      instructions: {},
      determinants: [],
    },
    {
      code: 'overdose-poisoning-indigestion',
      name: 'Overdose/Poisoning (Indigestion)',
      questions: [
        'Do you have any idea what the patient took?” Get the name of the product or substance.',
        'Was it a prescription medication, nonprescription over-the-counter medication, herbal supplement, street drug or a combination of medications?',
        'Has the patient consumed alcohol?',
        'If substance abuse, “Is the patient complaining of any pain?',
        'Is the patient having difficulty swallowing?',
        'Is the patient acting normally?” IF NOT, “What is different?',
      ],
      probableCause: ['Accidental', 'Intentional'],
      instructions: {},
      determinants: [],
    },
    {
      code: 'pandemic-epidemic-endemic',
      name: 'Pandemic/Epidemic/Endemic',
      questions: [
        'Any complaints around the area similar to that?',
        'Are you following necessary universal precautions?',
        'Is the person stable?',
        'Do you think it’s an infectious disease Please go to Infectious disease?',
      ],
      probableCause: [
        'Ebola',
        'Lassa Fever',
        'TB',
        'Hepatitis',
        'COVID-19',
        'Bird Flu',
        'STI',
        'Yellow Fever',
        'Typhoid',
      ],
      instructions: {},
      determinants: [],
    },
    {
      code: 'poisoning-substance-abuse-ingestions',
      name: 'Poisoning/substance Abuse/Ingestions',
      questions: [
        'Do you have any idea what the patient took? Get the name of the product or substance?',
        'Was it a prescription medication, nonprescription over-the-counter medication, herbal supplement, street drug or a combination of medications?',
        'Has the patient consumed alcohol?',
        'If substance abuse, Is the patient complaining of any pain?',
        'Is the patient having difficulty swallowing?',
        'Is the patient acting normally? IF NOT, What is different?',
      ],
      probableCause: ['Accidental', 'Intentional'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Keep the patient in the area/house, if safe. Get a container of substance taken, if at the scene. Do not force coffee or place patients in shower.Give nothing by mouth, including palm oil. Monitor patient’s breathing and level of consciousness.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-OD/Poisoning/Ingestions with these critical symptoms: Unconscious/not breathing normally. Any overdose of medication with altered level of consciousness. Substance abuse with critical symptoms. Ingestion of household cleaners, antifreeze, solvents, methanol, cyanide, insecticides. Difficulty swallowing. Alcohol intoxication, and the patient cannot be aroused. Combined alcohol and drug overdose.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-Drugs intentional/accidental ingestion without critical symptoms.- 3rd party report, caller not with patient. -Reported substance abuse, patient denies taking medications or unknown if medications/substance taken.- Known alcohol intoxication without other drugs can be aroused',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-Drugs intentional/accidental ingestion without critical symptoms.- 3rd party report, caller not with patient. -Reported substance abuse, patient denies taking medications or unknown if medications/substance taken.- Known alcohol intoxication without other drugs can be aroused',
        },
      ],
    },
    {
      code: 'pregnancy-childbirth-miscarriage',
      name: 'Pregnancy/Childbirth/Miscarriage',
      questions: [
        'Is this the first pregnancy?',
        'If this is not the first pregnancy, “How long was she in labor before delivery with her other pregnancies?',
        'Were there any complications?',
        'Was the delivery vaginal or surgical?',
        'How far along is she? If less than 20 weeks: Has there been any discharge of blood or tissue?',
        'Has she had any problems during pregnancy or anticipated problems?',
        'Is she having cramping pains that come and go? IF YES, How often? (Time from beginning of contraction to beginning of next contraction)?',
      ],
      probableCause: [
        'Infection',
        'Maternal Age',
        'Incompetent Cervix',
        'Uterine Abnormality',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Watch for the baby’s head to show. If the patient feels the urge to go to the bathroom, do not allow her to use the toilet! If a patient was on the toilet and noticed discharge of blood or tissue: “Do not flush the toilet or dispose of used pads.”If post delivery: “Is the baby breathing?” Give infant CPR instructions till first responders arrive.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Imminent delivery OR Delivery. -Vaginal bleeding with fainting. -Fainting/near fainting with the patient sitting up.- Prior history of complicated delivery.-Bleeding, greater than 20 weeks pregnant-Premature active labor -Abdominal injury, if greater than 20 weeks pregnant. -Seizure. -Multiple births.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-Delivery not imminent.-Vaginal bleeding without fainting if under 20 weeks pregnant. -Abdominal injury, if less than 20 weeks pregnant.-Water broke.- Pregnant less than 20 weeks or menstrual with any of the following: Cramps Pelvic Pain Spotting',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-Delivery not imminent.-Vaginal bleeding without fainting if under 20 weeks pregnant. -Abdominal injury, if less than 20 weeks pregnant.-Water broke.- Pregnant less than 20 weeks or menstrual with any of the following: Cramps Pelvic Pain Spotting',
        },
      ],
    },
    {
      code: 'psychiatric-abnormal-behavioral-suicide-attempt',
      name: 'Psychiatric/Abnormal Behavioral/Suicide Attempt',
      questions: [
        'If the caller knows the patient Is the patient acting in their normal manner? IF NOT What is different or unusual?',
        'Is the Patient: Acting violent, aggressive, shouting or yelling? Removing their clothing or naked? Sweating profusely?',
        'Breathing rapidly or drooling? (Excited Delirium)',
        'Is the patient a diabetic? Consider Diabetic problems',
        'Has the patient harmed themself? IF YES: (Consider traumatic injury section) IF NO, Do you think the patient might harm themself?',
        'Does the patient have a history of depression?',
        'Does the patient have a history of harming themselves or others?',
        'Has the patient ever attempted suicide?',
      ],
      probableCause: ['Depression', 'Anxiety', 'Schizophrenia', 'BAD'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Keep the patient in the area, if safe. Keep the patient calm, if possible. If you feel you are in danger, leave the scene. Gather patient medications, if any.  If suicide is indicated, try to determine the means. Alert responders to hazards such as gas, chemicals, weapons etc. ',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Decreased level of consciousness. -Patient presenting with Extreme violent or aggressive behavior Sweating profusely Removing clothes or naked Rapid breathing, drooling Incoherent shouting or yelling.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            'Lacerated wrist(s) with controlled bleeding. -Unusual behavior with a psychiatric history. Known alcohol intoxication without other drugs (can be aroused). -Threats against self or others.- Police request - Patient out of psychiatric medications.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            'Lacerated wrist(s) with controlled bleeding. -Unusual behavior with a psychiatric history. Known alcohol intoxication without other drugs (can be aroused). -Threats against self or others.- Police request - Patient out of psychiatric medications.',
        },
      ],
    },
    {
      code: 'sick-person',
      name: 'Sick Person',
      questions: [
        'Has the person lost weight?',
        'Any history of fever?',
        'Any history of diarrhoea?',
        'Any history of pain or headache?',
        'Any history of abdominal pain or swelling?',
        'Can the person speak?',
        'Is the person bedridden?',
        'Any past medical history?',
      ],
      probableCause: ['Infection', 'Cancer', 'Genetics'],
      instructions: {},
      determinants: [],
    },
    {
      code: 'stab-gunshot',
      name: 'Stab/Gunshot',
      questions: [
        'What part(s) of the body is injured?',
        'When did this happen?',
        'Was it intentional or an accident? If intentional, is assailant still present?',
        'What type of weapon was used?',
        'Is the weapon still present?',
        'Is more than one person injured',
        'Is there bleeding? If yes go to bleeding/laceration',
      ],
      probableCause: ['Gun', 'Knife'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: '- tell caller to remain safe(beware of assailant)- have the patient lie down, keep calm and warm',
        },
        Caller: {
          Text: 'Do not pull out any penetrating weapons',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-unconscious/not breathing-decreased level of consciousness -uncontrolled bleeding-wounds to head, neck, torso, or thigh-multiple casualty incident',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-Wounds to the arms below the elbow or on or below the knee',
        },
      ],
    },
    {
      code: 'stroke-cva-transient-ischemic-attack',
      name: 'Stroke (CVA)/Transient Ischemic Attack',
      questions: [
        'When did this start?',
        'Does the patient have: Sudden numbness or weakness of the face, arm or leg? (Especially on one side of the body.)',
        'Sudden confusion, trouble speaking (slurring) or understanding?',
        'Sudden trouble seeing in one or both eyes?',
        'Sudden trouble walking, dizziness, loss of balance or coordination?',
        'Sudden severe headache?',
        'Has the patient ever had a stroke?',
        'Has the patient had any recent injury/trauma?',
        'A history of diabetes?',
        'Any other medical or surgical history?',
      ],
      probableCause: ['Ischmeic', 'Hemorrhagic'],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: "Keep the patient calm. Don't allow the patient to move around. Nothing by mouth (to eat or drink). Gather patient medication, if any. ",
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Unconscious/not breathing normally. -Marked change in level of consciousness. -New onset of one sided weakness with paralysis, facial droop, slurred speech, confusion, loss of vision,loss of coordination, severe headache.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description: '-Past history of stroke (CVA) with no new changes',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description: '-Past history of stroke (CVA) with no new changes',
        },
      ],
    },
    {
      code: 'traffic-transportation-incidents',
      name: 'Traffic/Transportation Incidents',
      questions: [
        'Did you stop or drive by?',
        'What type of vehicle(s) are involved?',
        'How many patients are injured?',
        'Are all of the patients free of the vehicle?',
        'Is anyone trapped in the vehicle?',
        'Was anyone thrown from the vehicle?',
        'Are there any hazards present? (is the scene safe) is there a fire, fluids leaking, high tension electric wires',
        'Describe what happened, did the airbags deploy? How fast was the vehicle moving?',
      ],
      probableCause: ['Collision', 'Fall'],
      instructions: {},
      determinants: [],
    },
    {
      code: 'transfer-interfacility-palliative-care',
      name: 'Transfer/Interfacility/Palliative care',
      questions: [
        'Where are they taking the person to?',
        'Is the person stable?',
        'For what is the person being managed?',
      ],
      probableCause: [
        'Palliative',
        'Intensive Care',
        'Specialised Management',
        'Observation',
      ],
      instructions: {},
      determinants: [],
    },
    {
      code: 'traumatic-injuries',
      name: 'Traumatic Injuries',
      questions: [
        'How was the patient injured?',
        'Where is the patient injured?',
        'Is the patient bleeding? If yes go to the bleeding/laceration section ',
        'Indications of shock: is the patient’s skin cool and clammy, mottled, or profusely sweating?',
        'Is the patient’s breathing rapid and shallow?',
        'Are the patient’s pupils dilated?',
        'Does the patient appear confused?',
        'Does the patient feel weak or fatigued?',
        'Is the patient’s mouth dry or do they feel thirsty?',
      ],
      probableCause: [
        'Accident',
        'Fall',
        'Stab',
        'Gun Shot',
        'Physical Violence',
      ],
      instructions: {},
      determinants: [],
    },
    {
      code: 'unconscious-fainting-near',
      name: 'Unconscious/Fainting (Near)',
      questions: [
        'What was the patient doing before they became unconscious?',
        'Is this the first time today the patient has been unconscious?',
        'Has the patient taken any alcohol, medication or recreational drugs?',
        'Fainting “How does the patient act when they sit up?',
        'Is the patient able to respond to you and follow simple commands?',
        'Does the patient have any medical or surgical history?',
      ],
      probableCause: [
        'Cardiac Problem',
        'Endocrine Problem',
        'Pulmonary Problem',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'Have the patient lie down. If the patient is vomiting, lay the patient on their side. Monitor patient’s breathing.Do not leave the patient, be prepared to do CPR.Gather patient’s medications, if possible.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            '-Unconscious/not breathing normally.-Multiple fainting (syncopal) episodes (same day). -Confirmed unconscious/unresponsive.-Combined drugs and alcohol overdose. -Fainting associated with: Headache, Chest pain/discomfort/palpitations, Diabetic, GI/Vaginal Bleeding, Abdominal pain, Sitting/Standing, or continued decreased level of consciousness. -Single fainting if over 50 years. Alcohol intoxication, can not be aroused',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-Unconscious, but now conscious without critical symptoms. -Unconfirmed slumped over wheel. -Conscious with minor injuries. -Known alcohol intoxication without other drugs, can be aroused.-Near Syncope (fainting) without critical criteria.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-Unconscious, but now conscious without critical symptoms. -Unconfirmed slumped over wheel. -Conscious with minor injuries. -Known alcohol intoxication without other drugs, can be aroused.-Near Syncope (fainting) without critical criteria.',
        },
      ],
    },
    {
      code: 'unknown-problem-person-down',
      name: 'Unknown Problem (Person down)',
      questions: [
        'Are there any obvious injuries? What are they?',
        'Can you see blood or any other fluid around the patient?',
        'Are there any means of identification on the person?',
      ],
      probableCause: [
        'Resident',
        'Street',
        ' Work Place',
        'Restaurant',
        'Park',
      ],
      instructions: {
        Responders: {
          Text: '',
        },
        Dispatch: {
          Text: 'If there is no danger, go to the patient to see if the patient is awake, breathing normally, or moving at all. Watch and wait for the emergency responders and direct them to the patient.',
        },
        Caller: {
          Text: '',
        },
      },
      determinants: [
        {
          Severity: 'High',
          ResponderGroup: 'Alpha',
          Description:
            'Unconscious/not breathing normally. -Decreased level of consciousness.',
        },
        {
          Severity: 'Moderate',
          ResponderGroup: 'Beta',
          Description:
            '-Unknown (Third Party Call) without indications of unconsciousness. Patient talking, moving, sitting, or standing.',
        },
        {
          Severity: 'Low',
          ResponderGroup: 'Charlie',
          Description:
            '-Unknown (Third Party Call) without indications of unconsciousness. Patient talking, moving, sitting, or standing.',
        },
      ],
    },
    {
      code: 'vehicle-breakdown',
      name: 'Vehicle Breakdown',
      questions: [],
      probableCause: ['Flat tire'],
      instructions: {},
      determinants: [],
    },
  ],
}

export const severity_ = ['high', 'moderate', 'low']

export const inicident_types = [
  {
    name: 'Road traffic accident',
  },
  {
    name: 'Fire',
  },
  {
    name: 'Collapse building',
  },
  {
    name: 'Unconscious person on the road',
  },
  {
    name: 'Medical',
  },
  {
    name: 'Para-suicide',
  },
  {
    name: 'Active Shooter/Robbery',
  },
  {
    name: 'Violent Attack',
  },
  {
    name: 'Riot/Mob',
  },
]

export const ambulanceTypes = {
  basic_life_support_fleet: [
    'Airway and oxygen administration equipment',
    'Nebulizer',
    'Automated External Defibrillator',
    'Patient multiparameter monitor',
    'Immobilization devices e.g., cervical collar',
    'Dressing/Bleeding materials',
    'Trauma kit and Obstetric kit',
    'Over the counter medications',
    'Infection control kit',
    'Vascular access and consumables',
  ],
  advanced_life_support_fleet: [
    'CPAP/BPAP',
    'Ventilator',
    'ECG',
    'Airway and oxygen administration equipment',
    'Nebulizer',
    'Automated External Defibrillator',
    'Patient multiparameter monitor',
    'Immobilization devices e.g., cervical collar',
    'Dressing/Bleeding materials',
    'Advanced trauma kit and Obstetric kit',
    'Over the counter medications',
    'Infection control kit',
    'Vascular access and consumables',
  ],
  icu_fleet: [
    'Arterial Blood Gas monitor',
    'Electrocautery',
    'Central line kit',
    'CPAP/BPAP',
    'Ventilator',
    'ECG',
    'Airway and oxygen administration equipment',
    'Nebulizer',
    'Automated External Defibrillator',
    'Patient multiparameter monitor',
    'Immobilization devices e.g., cervical collar',
    'Dressing/Bleeding materials',
    'Advanced trauma kit and obstetric kit',
    'Over the counter medications',
    'Infection control kit',
    'Vascular access and consumables',
  ],
}
